import { SyncAdapter } from "./SyncAdapter";

/**
 * BroadcastChannelAdapter
 * Phase 1 implementation. Uses the browser's BroadcastChannel API
 * to sync events between the Host tab/window and the Projector tab/window
 * on the same device with zero network latency.
 *
 * Falls back to a no-op adapter in environments without BroadcastChannel.
 */
export class BroadcastChannelAdapter extends SyncAdapter {
  constructor(channelName = "ic-bingo-sync") {
    super();
    this.channelName = channelName;
    this.handlers = new Set();

    if (typeof window !== "undefined" && "BroadcastChannel" in window) {
      this.channel = new BroadcastChannel(channelName);
      this.channel.onmessage = (msg) => {
        this.handlers.forEach((h) => {
          try {
            h(msg.data);
          } catch (e) {
            console.error("[sync] handler error", e);
          }
        });
      };
    } else {
      this.channel = null;
    }
  }

  publish(event) {
    if (this.channel) {
      this.channel.postMessage(event);
    }
  }

  subscribe(handler) {
    this.handlers.add(handler);
    return () => this.handlers.delete(handler);
  }

  close() {
    if (this.channel) this.channel.close();
    this.handlers.clear();
  }
}
